import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Circle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const GOLD = '#8F650F';
const SAND = '#8A8175';

const Item = ({ done, label, detail, testId }) => (
  <div className="flex items-center gap-2" data-testid={testId} data-done={done ? 'true' : 'false'}>
    {done ? (
      <CheckCircle2 className="w-[15px] h-[15px] flex-shrink-0" style={{ color: GOLD }} />
    ) : (
      <Circle className="w-[15px] h-[15px] flex-shrink-0" style={{ color: 'rgba(138,129,117,0.55)' }} />
    )}
    <span
      className="font-mono text-[10px] uppercase font-semibold"
      style={{ letterSpacing: '0.18em', color: done ? GOLD : SAND }}
    >
      {label}
    </span>
    {detail && (
      <span className="font-display italic text-[12.5px]" style={{ color: SAND }}>
        {detail}
      </span>
    )}
  </div>
);

export const ModuleChecklist = ({ module, getAuthHeader, refreshKey }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!module?.id || !module?.course_id) return;
    let active = true;
    const load = async () => {
      try {
        const r = await axios.get(`${API}/learning/status/${module.course_id}/${module.id}`, getAuthHeader());
        if (active) setStatus(r.data);
      } catch { /* silent */ }
    };
    load();
    const iv = setInterval(load, 45000);
    return () => { active = false; clearInterval(iv); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module?.id, refreshKey]);

  if (!status) return null;

  const read = !!module?.user_progress?.completed;
  const mins = Math.floor((status.accumulated_seconds || 0) / 60);
  const reqMins = Math.round((status.required_seconds || 0) / 60);
  const hasTasks = (status.tasks_total || 0) > 0;
  const tasksDone = hasTasks && status.tasks_submitted >= status.tasks_total;
  const quizAttempted = (status.quiz_score || 0) > 0;

  return (
    <div
      className="mt-5 py-3 px-4 flex flex-wrap items-center gap-x-7 gap-y-2.5"
      style={{ border: '1px solid rgba(216,146,50,0.35)', backgroundColor: 'rgba(245,240,234,0.6)' }}
      data-testid="module-checklist"
    >
      <Item done={read} label="Gelesen" testId="checklist-item-read" />
      <Item
        done={!!status.time_completed}
        label="Lernzeit"
        detail={status.time_completed ? null : `${mins} / ${reqMins} Min.`}
        testId="checklist-item-time"
      />
      {hasTasks && (
        <Item
          done={tasksDone}
          label="Aufgaben"
          detail={tasksDone ? null : `${status.tasks_submitted} / ${status.tasks_total}`}
          testId="checklist-item-tasks"
        />
      )}
      <Item
        done={!!status.quiz_passed}
        label="Quiz"
        detail={status.quiz_passed ? `${Math.round(status.quiz_score)} %` : (quizAttempted ? `zuletzt ${Math.round(status.quiz_score)} %` : null)}
        testId="checklist-item-quiz"
      />
    </div>
  );
};

export default ModuleChecklist;
